// extracted by mini-css-extract-plugin
module.exports = {"card_play_content":"PlayCardSearch_card_play_content__1jeVA","card_play_vs":"PlayCardSearch_card_play_vs__24nTw","play_card_info":"PlayCardSearch_play_card_info__IGecj"};